import { css } from "lit";
export const styles = css`
  .subscribers-list {
    padding: 0;
    margin: 0;
  }

  .subscribers-list-item {
    list-style: none;
    display: flex;
    gap: 12px;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid var(--sds-color-border-default-secondary);
    color: var(--sds-color-text-default-secondary);
  }

  .subscribers-list-item p {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
  }

  .subscribers-list-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 44px;
    height: 44px;
    flex: 0 0 44px;
    border-radius: 50%;
    background-color: var(--sds-color-background-default-secondary);
  }
`;
